// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AuthTypeSchema = z.enum(['JWT','COOKIE','SSO','OAUTH','BASIC','OTHER'] as const);

export type AuthTypeType = `${z.infer<typeof AuthTypeSchema>}`

export default AuthTypeSchema;
